import React from "react";
import {  useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ingresoFoto } from "../../redux/actions";
import Button from "../../components/button";

function SubirFotoComponent({imagen,preview,handleBack}) {  

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleConfirmar = () => {
          dispatch(ingresoFoto(imagen))
          navigate('/ingreso_confirmacion')
  };

  return (
    <div>
      <div className="flex min-h-screen flex-col  items-center bg-[#F5FAFF]">
        {preview ? (
          <div className="flex flex-col  items-center">
            <img
              src={preview}
              alt="Imagen"
              className="w-[20rem] my-[3rem] rounded-lg overflow-hidden"
            />
            <div className="justify-center items-center flex">
              <div className="w-[21.5rem] justify-center items-center gap-2 inline-flex">
                <Button
                  variant="secondary"
                  size="lg"
                  fullWidth
                  onClick={handleBack}
                >
                  Volver atrás
                </Button>
                <Button
                  size="lg"
                  fullWidth
                  onClick={() => handleConfirmar()}
                >
                  Confirmar foto
                </Button>
              </div>
            </div>
          </div>
        ) : (
          
          <div>Hubo un problema al cargar la foto</div>
        )}

      </div>
    </div>
  );
}
export default SubirFotoComponent;
